import { Button, Card, Col, Form, Input, notification, Row, Divider } from 'antd'
import React from 'react'
import AppService from 'services/AppService'
import {SelectOutlined} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'

const ChangePasswordForm = () => {

    const [form] = Form.useForm();
    const history = useHistory()

    const handlePasswordChange = async(values) => {
        try{
            
            if(values.confirmPassword !== values.newPassword) {
                return notification.warning({message: "New password and confirm password not same"})
            }

            const res = await AppService.changePassword(values)
            notification.success({message: res})
            form.resetFields()

        }catch(err) {
            // console.log(err.response.data)
            notification.error({message: err?.response?.data ? err?.response?.data : "Unable to change password"})
        }
    }

  return (
    <>
    <div className='main'>
        <div className='container'>
           <Row>
    <Col span={24}>
        <Button 
            style={{backgroundColor:'#1677ff',color:'#fff', marginBottom: '20px'}} 
            icon={<SelectOutlined className="mb-3" size={20} />} 
            onClick={() => history.push("/app/profile/edit")}
            >
            Go Back
        </Button>
    </Col>
</Row>
  <Card style={{padding:"20px 2%"}}>
  <div className='settings-page-heading'>
    <h1>
        Change Password
    </h1>
  </div>
  
  <Divider></Divider>
  <Form layout='vertical' form={form} onFinish={handlePasswordChange}>
                    <Row gutter={10}>
                        <Col span={24} md={8}>
                            <Form.Item 
                                name="currentPassword" 
                                label="Current Password"
                                rules={[{required: true}]}
                            >
                                <Input.Password placeholder='Enter current password' />
                            </Form.Item>
                        </Col>
                        <Col span={24} md={8}>
                            <Form.Item 
                                name="newPassword" 
                                label="New Password"
                                rules={[{required: true}]}
                            >
                                <Input.Password placeholder='Enter new password' />
                            </Form.Item>
                        </Col>
                        <Col span={24} md={8}>
                            <Form.Item 
                                name="confirmPassword" 
                                label="Confirm Password"
                                rules={[{required: true}]}
                            >
                                <Input.Password placeholder='Enter confirm password' />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Button htmlType='submit' type='primary'>
                                Change Password
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>

        </div>
    </div>
    </>
  )
}

export default ChangePasswordForm